import iconFile from '../../assets/images/icon_stimulus.gif';
import { ItemStimulusSubTypes } from '../../lib/ItemUtil';
import TopBase, { type TopBaseProps } from '../lib/TopBase';

class StimulusTop extends TopBase {
    constructor(props: TopBaseProps) {
        super(props);
        this.type = 'stimulus';
        this.label = 'Stimulus';
        this.icon = iconFile;
        this.description = '[en]Experimental stimuli.[/en][ja]実験用刺激[/ja]';
        this.subTypes = ItemStimulusSubTypes;
    }
}

export default StimulusTop;
